module.exports = __webpack_public_path__ + "img/logo_horizontal.1c62c6d3.png";